<template>
  <div class="page-exhibition" :class="{'mobile': _isMobile}">
    <div class="exhibition-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="3"></cmpBanner>

      <div class="g-wrap">
        <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab>

        <div class="g-content">
          <div class="g-card-list">
            <div class="list" v-if="activeVal==='1' || activeVal==='2' || activeVal==='4'">
              <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
                <div class="pic-box pic1">
                  <img v-lazy="item.picture" alt="">
                </div>
                <div class="info m-circle">
                  <div>
                    <h2 class="title m-font-3 two-ell">{{item.name}}</h2>
                    <p class="addr m-font-4">{{item.position}}</p>

                    <p class="m-font-6 five-ell">{{item.text}}</p>
                  </div>

                  <p class="m-font-7 mt-10">
                    <span class="tag">{{item.subCategory}}</span>
                  </p>
                </div>
              </div>
            </div>

            <!-- 全景展厅 -->
            <el-row class="list list-2" :gutter="_isMobile?16:30" v-if="activeVal==='3' || activeVal==='5'">
              <el-col class="item g-card-3" :span="_isMobile?12:8" v-for="(item, index) in dataList" :key="index" @click.native="goOutLink(item)">
                <div class="pic-box">
                  <img v-lazy="item.picture" alt="">
                  <div class="icon-3d"></div>
                </div>
                <div class="info">
                  <p class="m-font-3 two-ell">{{item.name}}</p>
                </div>
              </el-col>
            </el-row>

            <!-- 无数据 -->
            <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
              <div class="no-data-bg"></div>
              <p class="txt text-center">暂无数据</p>
            </div>
          </div>


          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/exhibition/index.scss'
export default {
  watch: {
    $route(to, from) {
      this.activeVal = this.$route.query.pageType || '1'

      this.resetData()
    }
  },
  data() {
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '常设展览',
          val: '1'
        },
        {
          name: '临时展览',
          val: '2'
        },
        {
          name: '虚拟展厅',
          val: '3'
        },
        {
          name: '交流展览',
          val: '4'
        },
        {
          name: '云展览',
          val: '5'
        }
      ],
      dataList: [],
      listQuery: {
        page: 1,
        size: 10,
      },
      total: '0',
      listLoading: false,
    }
  },
  methods: {
    getDataList(val) {
      this.listLoading = true
      this.$http
        .get('/webapi/exhibition/list', {
          ...this.listQuery,
          type: this.activeVal // 1常设  3全景
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getDataList()
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getDataList()
    },
    goDetail(item) {
      console.log(item)
      this.$router.push({
        path: '/exhibition/detail',
        query: {id: item.id, pageType: this.activeVal}
      })
    },
    goOutLink(item) {
      item.url && window.open(item.url)
    },
    resetData() {
      this.listQuery.page = 1
      this.getDataList()
    }
  },
  created() {
    // this.getData()
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.exhibition-wrap {
  .list {
    width: 100%;
  }
  .list-2 {
    
  }
}
</style>


